<template>
    <div class="app">
        <div class="top">
            <!-- 左列表的数据 -->
            <div class="left">
                <!-- 搜索框 -->
                <div v-if="showSearch" class="search-box">
                    <el-input
                        v-model="leftSearch"
                        placeholder="搜索"
                        clearable
                        @input="handleLeftSearch"
                        size="small"
                    >
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
                <u-table :row-height="30" use-virtual :data="dataList.leftList" border
                    @selection-change="(val) => { handleSelectionChange(val, 'left') }" height="360">
                    <u-table-column type="selection" width="40"></u-table-column>
                    <u-table-column show-overflow-tooltip v-for="(tableValye, tableKey) in dataList.nameList"
                        :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField"
                        :min-width="tableValye.fieldWeight">
                    </u-table-column>
                </u-table>
            </div>
            <div class="opSetting">
                <el-button icon="el-icon-arrow-left" :disabled="Rightvalue.length ? false : true" size="medium"
                    type="primary" @click="RightSelect">
                </el-button>
                <el-button icon="el-icon-arrow-right" :disabled="Leftvalue.length ? false : true" size="medium"
                    type="primary" @click="LeftSelect">
                </el-button>
            </div>
            <!-- 右列表的数据 -->
            <div class="right">
                <!-- 搜索框 -->
                <div v-if="showSearch" class="search-box">
                    <el-input
                        v-model="rightSearch"
                        placeholder="搜索"
                        clearable
                        @input="handleRightSearch"
                        size="small"
                    >
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
                <u-table :row-height="30" use-virtual :data="dataList.rightList" border
                    @selection-change="(val) => { handleSelectionChange(val, 'right') }" height="360">
                    <u-table-column type="selection" width="40"></u-table-column>
                    <u-table-column show-overflow-tooltip v-for="(tableValye, tableKey) in dataList.nameList"
                        :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField"
                        :min-width="tableValye.fieldWeight">
                    </u-table-column>
                </u-table>
            </div>
        </div>
        <div class="bottom">
            <el-button type="" @click="closeClick">取消</el-button>
            <el-button type="primary" @click="openClick">确定</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "shuttleTable",
    props: {
        dataList: {
            type: Object,
            default: () => {
                return {
                    leftList: [],
                    rightList: [],
                    list: [],
                    nameList: [],
                };
            },
        },
        showSearch: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            Leftvalue: [], //选中的数据
            Rightvalue: [], //取消的数据
            leftSearch: '', // 左边列表搜索关键词
            rightSearch: '', // 右边列表搜索关键词
        };
    },
    methods: {
        handleSelectionChange(val, type) {
            if (type == 'left') {
                this.Leftvalue = val;
            } else {
                this.Rightvalue = val;
            }
        },
        // 左列表选中
        LeftSelect() {
            this.dataList.leftList = this.dataList.leftList.filter(item => {
                return this.Leftvalue.indexOf(item) == -1;
            });
            this.dataList.rightList = this.dataList.rightList.concat(this.Leftvalue);
            this.Leftvalue = [];
        },
        // 右列表取消
        RightSelect() {
            this.dataList.rightList = this.dataList.rightList.filter(item => {
                return this.Rightvalue.indexOf(item) == -1;
            });
            this.dataList.leftList = this.dataList.list.filter(item => {
                return this.dataList.rightList.indexOf(item) == -1;
            });
            this.Rightvalue = [];
        },
        closeClick(){
            this.$emit('closeClick')
        },
        openClick(){
            this.$emit('openClick',this.dataList.rightList)
        },
        // 左边列表搜索
        handleLeftSearch() {
            if (!this.leftSearch) {
                this.dataList.leftList = this.dataList.list.filter(item => {
                    return this.dataList.rightList.indexOf(item) == -1;
                });
                return;
            }
            const keyword = this.leftSearch.toLowerCase();
            this.dataList.leftList = this.dataList.list.filter(item => {
                if (this.dataList.rightList.indexOf(item) != -1) {
                    return false;
                }
                for (let key in item) {
                    if (typeof item[key] === 'string' && item[key].toLowerCase().includes(keyword)) {
                        return true;
                    }
                }
                return false;
            });
        },
        // 右边列表搜索
        handleRightSearch() {
            if (!this.rightSearch) {
                return;
            }
            const keyword = this.rightSearch.toLowerCase();
            // 注意：右边列表的搜索只是过滤显示，不会改变原始数据
        },
    },
};
</script>

<style scoped>
.top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.left {
    display: inline-block;
    width: 43%;
    min-width: 300px;
}

.right {
    display: inline-block;
    width: 43%;
    min-width: 300px;
}

.opSetting {
    min-width: 100px;
}
.bottom{
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.search-box {
    margin-bottom: 10px;
    width: 100%;
}
::v-deep(.el-checkbox){
    margin: 0px !important;
}
</style>